import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Container, Row, OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import ChemComponent from '../../ChemComponent';
import QueryTable from '../../QueryTable';

class KeyReport extends ChemComponent {
  	constructor(props) {
		super(props);
		
		this.state = {
			renderKey: 1,
			searchCount: null
		};
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
		
	render() {		
	
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Key Report',
			columns: exportColumns,
			entity: 'KEY_REPORT_VW',
			order: ['KEY_MAKER', 'KEY_NUMBER']
		});			

		return (<>
			<Container fluid>
				<Row style={{ paddingTop: '20px', paddingBottom: '20px', marginBottom: '20px', border: '1px solid #ccc',
					borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<Col xs={2}>
						<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Key Report</span>
					</Col>
					<Col xs={2} style={{ marginTop: 2}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					</Col>
					<Col xs={1}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					</Col>
					<Col xs={1}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					</Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_KeyReport' table={keyList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='100px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const keyList = {
	query: { entity: 'KEY_REPORT_VW', order: ['KEY_MAKER', 'KEY_NUMBER'] },
	pageSize: 20,
	columns: [
		{ Header: 'Make', accessor: 'KEY_MAKER' },
		{ Header: 'Key Number', accessor: 'KEY_NUMBER' },
		{ Header: 'Desc', accessor: 'KEY_DESC' },
		{ Header: 'Series', accessor: 'KEY_TYPE' },
		{ Header: 'Status', accessor: 'STATUS_NAME' }
	]
};

const exportColumns = [
		{ Header: 'Make', accessor: 'KEY_MAKER', width: 10 },
		{ Header: 'Key Number', accessor: 'KEY_NUMBER', width: 15 },
		{ Header: 'Desc', accessor: 'KEY_DESC', width: 20 },
		{ Header: 'Series', accessor: 'KEY_TYPE', width: 15 },
		{ Header: 'Status', accessor: 'STATUS_NAME', width: 15 }
];


export default KeyReport;